// extracted by mini-css-extract-plugin
export default {"row":"_1MKxxHzMnldDCeMtE8fkuE","name":"cq-YX1DPgEygS117GXqyf","size":"_1mZwoC31uiJ59jAtgd4HLq","control":"_3wCGbMUV8Rgej9csl2RECU"};